import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { TablePage } from "~/components/Table";
import { LqsNavigation } from "~/lqs";
import { DigestionPartFilters } from "./components/DigestionPartFilters";
import {
  DigestionPartSearchRequestProvider,
  DigestionPartTable,
} from "./components/DigestionPartTable";

export function DigestionPartsPage() {
  return (
    <TablePage
      title="Search Digestion Parts"
      navigation={<LqsNavigation />}
      RequestProvider={DigestionPartSearchRequestProvider}
      table={
        <>
          <DataStoreBreadcrumbs />
          <DigestionPartTable />
        </>
      }
      filters={<DigestionPartFilters />}
    />
  );
}
